<template>
	<div class="flex flex-col gap-[16px] bg-white rounded-[12px] overflow-hidden">
		<span class="bg-slate-100 w-full h-full min-h-[306px] max-h-[306px]"></span>
		<div class="intro-content">
			<div class="w-full h-[16px] bg-slate-100"></div>
			<div class="w-full h-[24px] bg-slate-100"></div>

			<div class="additional-info">
				<span class="items-stretch flex gap-2">
					<span
						class="aspect-square bg-slate-100 rounded-[32px] object-contain object-center w-[34px] overflow-hidden shrink-0 max-w-full"
					/>
					<div class="w-[200px] h-[16px] bg-slate-100"></div>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup></script>

<style lang="scss" scoped>
.additional-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	// gap: 12px;
}

.intro-content {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 0 16px;
	margin-bottom: 16px;
}
</style>
